//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global TrackpadScrollEmulator: false */

(function() {
  angular.module('curalate').service('ScrollEmulatorService', [
    function() {
      this.ORIENTATION = {
        VERTICAL: 'vertical',
        HORIZONTAL: 'horizontal',
      };

      this.setScrollableElement = function(elementSelector, orientation) {
        const el = angular.element(elementSelector);
        el.addClass('tse-scrollable');
        el.addClass(orientation);
        el.TrackpadScrollEmulator(); // eslint-disable-line new-cap
      };

      this.setHeight = function(elementSelector, height) {
        const el = angular.element(elementSelector);
        el.height(height);
        el.TrackpadScrollEmulator('recalculate'); // eslint-disable-line new-cap
      };
    },
  ]);
})();
